import { cn } from '@bem-react/classname';
import { IClassNameProps } from '@bem-react/core';
import React, { ComponentType } from 'react';

import './PopupList.scss';

export const cnPopupList = cn('PopupList');

type POPUP_LIST_ORIENTATION = 'vertical' | 'horizontal';

export interface WithOrientationProps {
    orientation?: POPUP_LIST_ORIENTATION;
}

export type IPopupListProps = IClassNameProps & WithOrientationProps;

export function withPopupListStyle<T>(Component: ComponentType<T>): ComponentType<T & IPopupListProps> {
    class WithPopupListStyle extends React.Component<T & IPopupListProps> {
        render() {
            const { orientation = 'horizontal', className, ...restProps } = this.props;

            return (
                <Component
                    {...(restProps as T)}
                    className={cnPopupList('', { orientation }, [className, 'IncrementSpecificity'])}
                />
            );
        }
    }

    return WithPopupListStyle;
}
